module.exports = __webpack_public_path__ + "img/slide-3.64fa5954.png";